import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Code, Cloud, Brain } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div 
            className="hero-text"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="hero-title">
              Empowering Businesses with
              <span className="gradient-text"> Innovative Software Solutions</span>
            </h1>
            
            <p className="hero-description">
              Noonic Solutions is your trusted partner in digital transformation. We provide cutting-edge 
              software solutions and expert IT manpower specializing in Fintech, ERP, Supply Chain Management, 
              SDLC, Cloud computing, and AI technologies.
            </p>
            
            <div className="hero-actions">
              <button className="btn btn-primary" onClick={scrollToContact}>
                Get Started
                <ArrowRight size={20} />
              </button>
              <button className="btn btn-outline" onClick={scrollToServices}>
                Our Services
              </button>
            </div>
          </motion.div>
          
          <motion.div 
            className="hero-visual"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="tech-icons">
              <div className="tech-icon">
                <Code size={40} />
                <span>SDLC</span>
              </div>
              <div className="tech-icon">
                <Cloud size={40} />
                <span>Cloud</span>
              </div>
              <div className="tech-icon">
                <Brain size={40} />
                <span>AI</span>
              </div>
            </div>
          </motion.div>
        </div>
        
        <motion.div 
          className="hero-stats"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <div className="stat">
            <h3>50+</h3>
            <p>Projects Delivered</p>
          </div>
          <div className="stat">
            <h3>25+</h3>
            <p>Expert Developers</p>
          </div>
          <div className="stat">
            <h3>98%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="stat">
            <h3>24/7</h3>
            <p>Support Available</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
